// assets/recently-viewed-products.js
/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts'; // [{id, handle}] newest-first
  static #MAX_PRODUCTS = 4;

  /**
   * @param {string|number} productId
   * @param {string} handle
   */
  static addProduct(productId, handle) {
    /** @type {{id:string,handle:string}[]} */
    let viewed = this.getProducts();

    // de-dupe by handle first (more useful client-side)
    viewed = viewed.filter(p => p.handle !== String(handle) && String(p.id) !== String(productId));

    viewed.unshift({ id: String(productId), handle: String(handle) });
    viewed = viewed.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewed));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /** @returns {{id:string,handle:string}[]} */
  static getProducts() {
    try {
      return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  }
}
